/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { memo, ReactElement } from 'react';
import classNames from 'classnames';
import { CellAlign } from '../cell-align/CellAlign';
import { TableRenderComponents, TTableColumn } from '../../models';
import { formatCellByColumnType } from '../../utils';
import { EditRow } from '../row-fields/editable-row/EditRow';
import { IdType, Row } from 'react-table';
import { Identifiable } from '@custis/common';
import s from './GridRow.module.less';
import { observer } from 'mobx-react';

interface Props<TItem extends Identifiable, TFilter, TSorting> {
  row: Row<TItem>;
  editedRow?: Partial<TItem>;
  allColumns: TTableColumn<TItem, TFilter, TSorting>[];
  subRowColumns?: TTableColumn<TItem, TFilter, TSorting>[];
  editEnabled: boolean;
  subRowEditEnabled?: boolean;
  hiddenColumns: IdType<TItem>[];
  subRowIdSeparator?: string;

  onEditRow?(row: TItem): Promise<void>;

  onEditSubRow?(row: TItem): Promise<void>;

  onFormChange?(row: Partial<TItem>): void;

  onHideEditRow(): void;
}

const GridRowInner = observer(
  <TItem extends Identifiable, TFilter, TSorting>({
    allColumns,
    onEditRow,
    onFormChange,
    onHideEditRow,
    row,
    editedRow,
    editEnabled,
    subRowColumns,
    subRowEditEnabled,
    onEditSubRow,
    hiddenColumns,
    subRowIdSeparator = '-',
  }: Props<TItem, TFilter, TSorting>) => {
    if (editEnabled) {
      return (
        <EditRow
          key={'editedRow' + row.id}
          cells={row.cells}
          onHide={onHideEditRow}
          columns={allColumns}
          onEdit={onEditRow}
          data={editedRow}
          cellClassName={s.GridCell}
          onFormChange={onFormChange}
          originalRow={row.original}
          visible={editEnabled}
          hiddenColumns={hiddenColumns}
        />
      );
    }

    if (subRowColumns && subRowEditEnabled && onEditSubRow) {
      return (
        <EditRow
          key={'subEditedRow' + row.id}
          cells={row.cells}
          onHide={onHideEditRow}
          columns={subRowColumns}
          onEdit={onEditSubRow}
          data={editedRow}
          cellClassName={s.GridCell}
          onFormChange={onFormChange}
          originalRow={row.original}
          visible={subRowEditEnabled}
          hiddenColumns={hiddenColumns}
        />
      );
    }

    return (
      <>
        {row.cells.map((cell, idx) => {
          const cellProps = cell.getCellProps();
          cellProps.style = {
            ...cellProps.style,
            display: 'inline-flex',
          };
          return (
            <div
              {...cellProps}
              key={`${row.id}${subRowIdSeparator}${idx}`}
              className={classNames(s.GridCell, cellProps.className)}
              onClick={void 0}
            >
              <CellAlign type={(cell.column as TTableColumn<TItem, TFilter, TSorting>).type}>
                {formatCellByColumnType(
                  cell.render(TableRenderComponents.Cell) as ReactElement,
                  cell.column as TTableColumn<TItem, TFilter, TSorting>,
                )}
              </CellAlign>
            </div>
          );
        })}
      </>
    );
  },
);

export const GridRow = memo(GridRowInner) as typeof GridRowInner;
